// components/ToggleSwitch.jsx
import React from 'react';
import '../styles/ToggleSwitch.css';

const ToggleSwitch = ({ 
  checked, 
  onChange, 
  disabled = false,
  label,
  name 
}) => {
  const handleToggle = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  return (
    <div className="toggleContainer">
      {label && <span className="toggleLabel">{label}</span>}
      <div 
        className={`toggleSwitch ${checked ? 'toggleChecked' : ''} ${disabled ? 'toggleDisabled' : ''}`}
        onClick={handleToggle}
      >
        <div className="toggleSlider">
          <div className="toggleThumb" />
        </div>
        <input
          type="checkbox"
          name={name}
          checked={checked}
          onChange={() => {}}
          disabled={disabled}
          className="toggleInput"
        />
      </div>
    </div>
  );
};

export default ToggleSwitch;